import type { ReactNode } from "react";

import styled from "styled-components";

import { colorsPalettes, fonts, setFont } from "@similarweb/styles";
import type { DifficultyLevel } from "app/pages/digital-marketing/difficulty-bar/DifficultyBar.utils";
import { MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR } from "app/pages/digital-marketing/difficulty-bar/DifficultyBar.utils";

const CIRCLE_STYLES = {
    size: "12px",
};

const DifficultyBarRowWrapper = styled.div.attrs<{ "data-automation-difficulty-bar-header"?: boolean }>((props) => ({
    "data-automation-difficulty-bar-header": true,
}))`
    display: flex;
    align-items: center;
    margin-left: 6px;
    cursor: default;
`;

const DifficultyGradeIndicator = styled.div<{ fontSize: number }>`
    margin-left: 10px;
    ${(props) =>
        setFont({
            $size: props.fontSize,
            $family: fonts.$dmSansFontFamily,
            $color: colorsPalettes.carbon["400"],
            $weight: 500,
        })}
`;

const DifficultyLevelLabel = styled.div<{ fontSize: number }>`
    margin-left: 4px;
    line-height: 20px;
    ${(props) =>
        setFont({
            $size: props.fontSize,
            $family: fonts.$dmSansFontFamily,
            $color: colorsPalettes.carbon["300"],
            $weight: 500,
        })}
`;

const Circle = styled.div<{ background: string; size: string }>`
    background: ${({ background }) => background};
    border-radius: 50%;
    width: ${({ size }) => size};
    height: ${({ size }) => size};
`;

type RenderDifficultyBarHeaderProps = {
    difficultyLevel: DifficultyLevel;
    difficultyGrade: number;
    labelText: ReactNode;
    fontSize?: number;
};

export const DifficultyBarRow = ({
    difficultyLevel,
    difficultyGrade,
    labelText,
    fontSize = 16,
}: RenderDifficultyBarHeaderProps) => {
    return (
        <DifficultyBarRowWrapper>
            <Circle
                {...CIRCLE_STYLES}
                background={MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR[difficultyLevel]}
            />
            <DifficultyGradeIndicator fontSize={fontSize}>{difficultyGrade}</DifficultyGradeIndicator>
            <DifficultyLevelLabel fontSize={fontSize}>({labelText})</DifficultyLevelLabel>
        </DifficultyBarRowWrapper>
    );
};
